import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import get from "lodash/get";
import useStore from "../../store";
import useTranslation from "../../hooks/useTranslation";
import "./products.scss";

export default function Products() {
  const { id } = useParams();
  const [isFetched, setIsFetched] = useState(false);
  const { products, setProducts, selectedCategory } = useStore((s) => s);
  const { tr } = useTranslation();

  useEffect(() => {
    if (!selectedCategory) return;
    setIsFetched(false);
    fetchProducts();
    // eslint-disable-next-line
  }, [selectedCategory]);

  function fetchProducts() {
    axios({
      url: `${
        process.env.REACT_APP_API_URL
      }online-menu/${id}/dishes?time=${Date.now()}`,
      params: {
        company_id: id,
        menu_id: selectedCategory,
        per_page: 100,
        include: "file",
      },
      method: "GET",
    })
      .then((res) => {
        const list = res?.data?.data || [];
        setProducts(Array.isArray(list) ? list : []);
        setIsFetched(true);
      })
      .catch(() => setIsFetched(true));
  }

  return (
    <div className="products">
      {!isFetched && (
        <div className="products__grid">
          {Array.from({ length: 8 }).map((_, i) => (
            <div className="card card--skeleton" key={i}>
              <div className="card__media skeleton" />
              <div className="card__body">
                <div className="skeleton skeleton--text w-70" />
                <div className="skeleton skeleton--text w-90" />
                <div className="skeleton skeleton--price w-40" />
              </div>
            </div>
          ))}
        </div>
      )}

      {isFetched && products?.length > 0 && (
        <div className="products__grid">
          {products.map((p) => (
            <Item key={p.id} product={p} />
          ))}
        </div>
      )}

      {isFetched && (!products || products.length === 0) && (
        <div className="no-food">
          <div className="no-food__icon">
            <i className="fas fa-utensils"></i>
          </div>
          <h3 className="no-food__title">{tr("Товары отсутствуют")}</h3>
          <p className="no-food__message">
            {tr("В этой категории пока нет товаров")}
          </p>
        </div>
      )}
    </div>
  );
}

function Item({ product }) {
  const { tr } = useTranslation();
  const { company } = useStore((s) => s);
  const currency = get(company, "setting.default_currency_code", "");
  const img = product?.file?.thumbnails?.normal?.src || null;
  const price = Number(product?.price || 0);
  const oldPrice = Number(product?.old_price || 0);
  const hasDiscount = oldPrice > 0 && price < oldPrice;
  const discountPercent = hasDiscount
    ? Math.round(((oldPrice - price) / oldPrice) * 100)
    : 0;

  return (
    <div
      className={`card-new ${
        Number(product.quantity) === 0 && product.quantity !== null
          ? "card-new-disable"
          : ""
      }`}
    >
      <div className="card-new__media">
        {img ? (
          <img src={img} alt={product?.name || tr("Блюдо")} loading="lazy" />
        ) : (
          <div className="card-new__placeholder">
            <img
              src={process.env.PUBLIC_URL + "/no-food.png"}
              alt={tr("Нет фото")}
            />
          </div>
        )}
        {hasDiscount && discountPercent > 0 && (
          <div className="card-new__discount-badge">-{discountPercent}%</div>
        )}
      </div>

      <div className="card-new__body">
        <div className="card-new__prices">
          {hasDiscount && (
            <span className="card-new__old-price">
              {oldPrice.toLocaleString("uz-UZ")} {tr(currency)}
            </span>
          )}
          <span
            className={`card-new__price ${hasDiscount ? "card-new__price--discount" : ""}`}
          >
            {price.toLocaleString("uz-UZ")} {tr(currency)}
          </span>
        </div>
        <h3 className="card-new__title">{product?.name}</h3>
        <p className="card-new__calorie">{product?.calorie}</p>
      </div>
    </div>
  );
}
